<template>
  <div class="pwdchange">
    <div class="card-box-pwd pwdform">
      <h3 class="title">{{systemName}}</h3>

      <el-row class="pwdchange-row">
        <el-col :span="9" class="pwdchange-label">

          <el-row>
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div style="width: 140px;margin-top: 0.5em">得意先コード</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div style="width: 180px;margin-top: 3em">現在のパスワードを表示</div>
            </el-col>
          </el-row>

        </el-col>
        <el-col :span="15" class="pwdchange-input">
          <el-form :model="form1" :rules="rules1" ref="form1" label-position="left" label-width="0">
          <el-row>
            <el-col :span="14">
              <el-form-item prop="clientId" >
                <el-input type="text" class="pwdchange-el-input" v-model="form1.clientId" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item >
                <el-button type="danger" class="pwdchange-btn-left" style="margin-top: 29px" @click.native.prevent="getPasswordByClientId('form1')">確認</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          </el-form>
          <el-row>
            <el-col :span="24">
              <div style="margin-left: 2em;margin-top: 1.2em;border-bottom: groove;width: 42%">{{nowPwd}}</div>
            </el-col>
          </el-row>
        </el-col>

      </el-row>
      <el-form :model="form" :rules="rules2" ref="form" label-position="left" label-width="0">
      <el-row>
        <el-col :span="9"class="pwdchange-label-big">

          <el-row >
            <el-col :span="24">
              <div class="login-integrant" style="margin-top: 1em">必須</div>
            </el-col>
          </el-row>

          <el-row >
            <el-col :span="24">
              <div style="width: 180px;margin-top: 3em">新規パスワード設定</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div style="width: 180px;margin-top: 6.5em">新パスワード表示</div>
            </el-col>
          </el-row>

        </el-col>
        <el-col :span="15" class="pwdchange-input-big">

          <el-row>
            <el-col :span="24">
              <el-form-item prop="password">
                <el-input type="password" class="pwdchange-el-input" v-model="form.password"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div style="margin-left: 2em">確認のため、再度パスワードを入力してください</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item prop="repassword">
                <el-input type="password" class="pwdchange-el-input" v-model="form.repassword"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item >
                <el-button type="danger" class="pwdchange-btn-left" :loading="loading" style="margin-top: 29px" @click.native.prevent="updatePasswordByClientId('form','form1')">確認</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="margin-left: 2em;margin-top: 0.8em;border-bottom: groove;width: 42%">{{newPwd}}</div>
            </el-col>
          </el-row>

        </el-col>

      </el-row>
      <el-row style="text-align: center">
        <el-col :span="24">
          <el-form-item >
            <el-button type="danger" class="pwdchange-btn-left" @click.native.prevent="end('form1','form')">終　了</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _g from '@/assets/js/global'
  import { isValidPwd, isUserId } from '../../assets/js/check'

  export default {
    data() {
      var checkUserId = (rule, value, callback) => {
        if (value == null || value == '') {
          callback(new Error('得意先コードを入力してください。'))
        } else {
          callback()
        }
      }
      var password = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('パスワードを入力してください。'))
        } else if (!isValidPwd(value)) {
          callback(new Error('パスワードは8桁～10桁の英数字混在を入力してください。'))
        } else if (this.nowPwd === value) {
          callback(new Error('元パスワードと同じです！'))
        } else {
          callback()
        }
      }
      var repassword = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('再度パスワードを入力してください。'))
        } else if (this.form.password !== value) {
          callback(new Error('パスワードが不一致ので、確認してください。'))
        } else {
          callback()
        }
      }
      return {
        title: '',
        systemName: 'パスワード変更／確認機能',
        nowPwd: 'これは元パスワードです',
        newPwd: 'これは新パスワードです',
        userFLG: false,
        loading: false,
        form1: {
          clientId: ''
        },
        form: {
          password: '',
          repassword: ''
        },
        rules1: {
          clientId: [
            { required: true, validator: checkUserId, trigger: 'blur' }
          ]
        },
        rules2: {
          password: [
            { required: true, validator: password, trigger: 'blur' }
          ],
          repassword: [
            { required: true, validator: repassword, trigger: 'blur' }
          ]
        },
        checked: false
      }
    },
    methods: {
      end (from1, from) {
        window.localStorage.setItem('userId', '')
        this.resetCommonData('/shanaikanrisha/login')
        _g.toastMsg('success', '再ログインしてください。')
      },
      getPasswordByClientId(form) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {}
            data.clientId = this.form1.clientId
            this.apiPost('shanaikanrisha/ChangePassword/getPasswordByName', data).then((res) => {
              this.handelResponse(res, (data) => {
                this.nowPwd = data
                this.userFLG = true
              })
            })
          }
        })
      },
      updatePasswordByClientId(form, form1) {
        this.$refs[form1].validate((valid) => {
          if (!valid) {
            return
          }
        })
        this.$refs[form].validate((valid) => {
          if (valid) {
            if (!this.userFLG) {
              this.loading = false
              _g.toastMsg('error', '得意先コードを確認したの場合、パスワードを変更できます！')
              return
            }
            let data = {}
            data.clientId = this.form1.clientId
            data.userId = window.localStorage.getItem('userId')
            data.password = this.form.password
            var pwd = this.form.password
            this.loading = true
            this.apiPost('shanaikanrisha/ChangePassword/updateUserPassword', data).then((res) => {
              this.loading = false
              this.handelResponse(res, (data) => {
                if (res.code != 200) {
                  this.handleError(res)
                } else {
                  this.newPwd = pwd
                  _g.toastMsg('success', 'パスワードを変更しました!')
                  window.localStorage.setItem('userId', '')
                }
              })
            })
          }
        })
      }
    },
    mixins: [http]
  }
</script>

<style>
  @import url("../../assets/css/common.css");

  .pwdchange-el-input{
    margin: 29px 20px 0px 20px;
  }
  .pwdchange-row{
    margin-bottom: 0.1em;
  }
  .pwdchange-input{
    height: 150px;
    background-color:#F5F7F7;
  }
  .pwdchange-input-big{
    height: 280px;
    background-color:#F5F7F7;
  }
  .pwdchange-label{
    height: 150px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .pwdchange-label-big{
    height: 280px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .pwdchange-btn-left{
    margin-top: 1em;
    width: 150px;
  }

  .card-box-pwd {
    padding: 5em;
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 5em auto;
    width: 45em;
    border: 0.1em solid #8492A6;
  }

  .title {
    margin: 0px auto 2em auto;
    text-align: left;
    color: #505458;
  }

  .pwdform {
    padding: 3em 3em 0.1em 3em
  }
</style>
<style>
  .pwdchange .el-input{
    width: 15em
  }
  .pwdchange .el-form-item__error{
    left: 8%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shanaikanrisha/changePwd.vue